// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__6sVN8","text":"styles_text__snNpV"};